import {createRouter,createWebHashHistory} from "vue-router";
import { getItem } from "@/utils/storage"; 
import { ElMessage } from 'element-plus'

const routes = [
    {
        path:'/login',
        name:'login',
        component:()=>import('@/views/login/login.vue'),
        
    },
    
    {
        path:'/',
        name:'home',
        component:()=>import('@/components/mainIndex/index.vue'),
        children:[
            {
                path: '',
                name: 'homeIndex',
                component: () => import('@/views/home.vue'),
                meta:{
                    index1:'首页'
                }
            },
            {
                path: 'integral',
                name: 'integral',
                component: () => import('@/views/integral.vue')
            },
            {
                path: 'mine',
                name: 'mine',
                component: () => import('@/views/mine.vue')
            },
            // 自助积分
            {
                path: 'selfintegral',
                name: 'selfintegral',
                component: () => import('@/views/selfIntegral.vue')
            },
            // 积分记录
            {
                path: 'integralList',
                name: 'integralList',
                component: () => import('@/views/integralList.vue')
            },
            // 积分小票上传
            {
                path: 'receiptsubmit',
                name: 'receiptsubmit',
                component: () => import('@/views/receiptSubmit.vue')
            },
            // 停车缴费
            {
                path: 'licencePlate',
                name: 'licencePlate',
                component: () => import('@/views/licencePlate.vue')
            },
            // 品牌导览
            {
                path: 'merchant',
                name: 'merchant',
                component: () => import('@/views/merchant.vue')
            },
            // 商户详情
            {
                path: 'merchantInfo',
                name: 'merchantInfo',
                component: () => import('@/views/merchantInfo.vue')
            },
            // 招商列表
            {
                path: 'newslist',
                name: 'newslist',
                component: () => import('@/views/newsList.vue')
            },
            // 招商详情
            {
                path: 'newsinfo',
                name: 'newsinfo',
                component: () => import('@/views/newsInfo.vue')
            },
            // 商品详情
            {
                path: 'shopinfo',
                name: 'shopinfo',
                component: () => import('@/views/shopInfo.vue')
            },
            // 优惠券列表页面
            {
                path: 'couponList',
                name: 'couponList',
                component: () => import('@/views/couponList.vue')
            },
            // 兑换订单
            {
                path: 'convertOrder',
                name: 'convertOrder',
                component: () => import('@/views/convertOrder.vue')
            },
            // 编辑用户信息
            {
                path: 'edituser',
                name: 'edituser',
                component: () => import('@/views/edituser.vue')
            },
            // 优惠券详情
            {
                path: 'couponinfo',
                name: 'couponinfo',
                component: () => import('@/views/couponInfo.vue')
            },
            // 商户核销券码
            {
                path: 'merchhantcode',
                name: 'merchhantcode',
                component: () => import('@/views/merchantCheckCode.vue')
            },
            // 商户核销记录
            {
                path: 'merchhantcheckList',
                name: 'merchhantcheckList',
                component: () => import('@/views/checkList.vue')
            },
            // 资讯列表
            {
                path: 'messageList',
                name: 'messageList',
                component: () => import('@/views/messageList.vue')
            },
            // 小票示例
            {
                path: 'selfExample',
                name: 'selfExample',
                component: () => import('@/views/selfExamp.vue')
            },
        ]
    },
    
]

const router=createRouter({
    history:createWebHashHistory(),
    mode:'hash',
    routes
 
})

// 创建路由导航守卫
router.beforeEach(async (to, from, next) => {
  
    // if (to.name !== 'login' && to.name!=='loginsys' && to.name!=='register' && !getItem("tokens")) {
    // // 如果用户未经身份验证且访问的不是登录页，则重定向到登录页
    // // ElMessage.error("请先登录！");
    // next({name:"login"})
    //  } else {
        next();
    //  }
});


export default router